export const imageUrlCache = new Map();
export const pendingImageUrlRequests = new Map();
